export const DEFAULT_BASE_URL = 'https://api-beta-restockify.shopgram.app';
export const CANNY_BOARD_TOKEN = 'f59c68b9-8292-3688-794a-d79a4d4afa72';
export const CANNY_APP_ID = '60740e55e7ff7c60ea60a308';

export const PATHS = {
  HOME: '/',
  HELP: '/help',
  LOGIN: '/support/login/',

  PRICING: '/plans',
  // Discount Prime's Campaigns/Analytics/Wholesale Tools pages were removed
  // (see docs/prime-moq-mockup-v3.html — Prime MOQ has no equivalent yet).
  // These three are kept as aliases to /rules rather than deleted outright:
  // a handful of dashboardV2 widgets (CreateCampaignBanner, DashboardCampaignBar,
  // WholesaleB2bBanner, etc.) still link to them with Discount-Prime-flavored
  // copy — functional but stale, pending the dashboard copy/design review pass.
  CAMPAIGNS: '/rules',
  CREATE_CAMPAIGN: '/rules/create-selected-rule',
  CREATE_CAMPAIGNold: '/rules/create-selected-rule',
  ANALYTICS: '/rules',
  WHOLESALE_TOOLS: '/rules',
  SETTING: '/setting',
  PREFERENCES: '/preferences',
  DESIGN: '/design',
  HELP_SUB_PAGES: {
    CREATE_CAMPAIGN: 'create-campaign',
    IMPORTANT_TIPS: 'important-tips',
    FAQ: 'faq',
    CONTACT_US: 'contact-us',
    feature_request: 'feature-request',
  },
  SETTING_SUB_PAGES: {
    custom_notifications: 'customer-notification',
    MANAGE_DISCOUNTS: 'manage-discounts',
    Label_DISCOUNTS: 'lable-discount',
    blocked_order_alerts: 'blocked-order-alerts',
  },
  RULES: '/rules',
  CREATE_RULE: '/rules/create-rule',
  EDIT_RULE: '/rules/edit-rule',
  SELECT_RULE_TYPE: '/rules/create-selected-rule',
  RULES_OVERLAPS: '/rules/overlaps',
  RULES_CHECK_PRODUCT: '/rules/check',
  SAFE_UNINSTALL: '/safe-uninstall',
  AUTOMATIONS: '/automations',
  // Pro features C (blocked-order email alerts) and E (CSV import/export +
  // public API) both live inside Settings now, and D ("Blocked cart value"
  // reports) lives on the Dashboard. All three paths are kept only as
  // redirects (see Router.js) for old links/bookmarks.
  ALERTS: '/alerts',
  INTEGRATIONS: '/integrations',
  REPORTS: '/reports',
};

export const PRICING_PERIODS = {
  MONTH: 0,
  YEAR: 1,
};
export const TABLE_ROWS_PER_PAGE = 10;

export const primaryDiscountRule = {
  discountType: 0,
  discountValue: '',
  minValue: '',
  maxValue: '',
  minType: 1,
};

export const campaignTypes = {
  General: true,
  Volume: false,
  Order: 0,
  BOGO: 3,
  BOGOPurchase: 4,
  Countdown: 5,
  Shipping: 6,
  Bundle: 7,
  CrossSell: 8,
  Wholesale: 9,
  Dropshipper: 10,
};

export const campaignFocusedTypes = {
  countdown: 'countdown',
};

// Maps a campaign type (campaignTypes value) to the plan feature key that gates
// it. A type is "locked" for a shop when this key is NOT in the shop's
// currentPlanFeatureKeys. Single source of truth shared by the type-selection
// screen and the campaign builder's "will be blocked" detection.
export const campaignTypeFeatureKey = {
  [campaignTypes.General]: 'flat-product-discount',
  [campaignTypes.Volume]: 'tiered-quantity-discount',
  [campaignTypes.Order]: 'tiered-spend-discount',
  [campaignTypes.BOGO]: 'buy-x-get-y',
  [campaignTypes.BOGOPurchase]: 'buy-x-get-y',
  [campaignTypes.Shipping]: 'free-shipping',
  [campaignTypes.Wholesale]: 'wholesale-b2b-pricing',
  [campaignTypes.Dropshipper]: 'dropshipper-pricing',
};

export const serverCampaignTypes = {
  General: 'general',
  Volume: 'volume',
  Order: 'order',
  BOGO: 'buy_one_get_one',
  Shipping: 'shipping',
  Bundle: 'bundles',
  CrossSell: 'cross_sell',
  Wholesale: 'wholesale',
  Dropshipper: 'dropshipper',
};

export const bogoDiscountType = {
  minimumQuantity: 0,
  minimumPurchaseAmount: 1,
};

export const campaignMinType = {
  minimumQuantity: 0,
  minimumPurchaseAmount: 1,
  noMin:2
};

export const discountTypes = {
  percentage: 0,
  fixPrice: 1,
  newPrice: 2,
  freeShipping: 3,
};

export const newPriceDiscountTypes = {
  percentage: 0,
  fixPrice: 1,
  newPrice: 2,
};

export const newPriceChangeModeType = {
  increase: 0,
  decrease: 1,
};

// Dropshipper Pricing — what the discount/repricing is computed against.
//   sellingPrice → plain discount off the selling price (manual price floor)
//   profitMargin → discount comes out of the margin (cost + min-profit floor)
//   productCost  → selling price is rebuilt from cost (cost + markup)
export const pricingBaseTypes = {
  sellingPrice: 0,
  profitMargin: 1,
  productCost: 2,
};

export const campaignCustomerGetType = {
  free: 1,
  percentage: 2,
  fixPrice: 3,
  freeShipping: 4,
};

export const campaignCustomerGetProductType = {
  sameProduct: 'sameProduct',
  selectProduct: 'selectProduct',
};

export const campaignWidgetStyle = {
  none: 'none',
  modal: 'modal',
  toast: 'toast',
};
